module.exports = __webpack_public_path__ + "img/yiling@2x.065c2e6c.png";